// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-recovery-page {
  --wallet-bg-1: #07131b;
  --wallet-bg-2: #0b1d29;
  --wallet-bg-3: #04080c;
  --wallet-emerald: #31e6a4;
  --wallet-gold: #f0ca73;
  --wallet-text: #f5f0e5;
  --wallet-text-soft: rgba(233, 238, 241, 0.74);
  --wallet-panel: rgba(7, 16, 22, 0.96);
  --wallet-border: rgba(100, 197, 170, 0.14);
  min-height: 100vh;
  min-height: 100dvh;
  position: relative;
  overflow: hidden;
  display: grid;
  place-items: center;
  padding:
    calc(16px + var(--app-safe-top, 0px))
    calc(16px + var(--app-safe-right, 0px))
    calc(20px + var(--app-safe-bottom, 0px))
    calc(16px + var(--app-safe-left, 0px));
  color: var(--wallet-text);
  background:
    radial-gradient(circle at top center, rgba(53, 109, 92, 0.26) 0%, rgba(7, 19, 27, 0) 34%),
    radial-gradient(circle at 18% 82%, rgba(240, 202, 115, 0.1) 0%, rgba(7, 19, 27, 0) 28%),
    linear-gradient(180deg, var(--wallet-bg-1) 0%, var(--wallet-bg-2) 52%, var(--wallet-bg-3) 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;
}

.wallet-recovery-page::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px);
  background-size: 16px 16px;
  opacity: 0.5;
}

.wallet-recovery-shell {
  position: relative;
  width: min(100%, 440px);
  padding: 18px;
  border-radius: 28px;
  overflow: hidden;
  background: var(--wallet-panel);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 28px 56px rgba(0, 0, 0, 0.42);
}

.wallet-recovery-shell__noise,
.wallet-recovery-shell__halo {
  position: absolute;
  pointer-events: none;
}

.wallet-recovery-shell__noise {
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.014) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.01) 1px, transparent 1px);
  background-size: 12px 12px;
  opacity: 0.22;
}

.wallet-recovery-shell__halo {
  width: 220px;
  height: 220px;
  border-radius: 50%;
  filter: blur(34px);
}

.wallet-recovery-shell__halo--top {
  top: -110px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(24, 180, 127, 0.14);
}

.wallet-recovery-shell__halo--bottom {
  right: -100px;
  bottom: -130px;
  background: rgba(240, 202, 115, 0.08);
}

.wallet-recovery-brand,
.wallet-recovery-card {
  position: relative;
  z-index: 1;
}

.wallet-recovery-brand {
  display: grid;
  gap: 14px;
  justify-items: center;
  text-align: center;
  margin-bottom: 16px;
}

.wallet-recovery-brand__logo {
  width: 96px;
  max-width: 38vw;
  object-fit: contain;
  filter: drop-shadow(0 14px 24px rgba(0, 0, 0, 0.34));
}

.wallet-recovery-brand__copy span {
  display: block;
  font-size: 0.74rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(233, 238, 241, 0.6);
}

.wallet-recovery-brand__copy h1 {
  margin: 6px 0 0;
  font-size: clamp(1.1rem, 4.8vw, 1.45rem);
  line-height: 1.18;
  font-weight: 700;
}

.wallet-recovery-card {
  display: grid;
  gap: 14px;
}

.wallet-recovery-stepper {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.wallet-recovery-stepper span {
  padding: 9px 10px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  color: var(--wallet-text-soft);
  text-align: center;
  font-size: 0.76rem;
}

.wallet-recovery-stepper .is-active {
  color: #eafff7;
  border-color: rgba(49, 230, 164, 0.22);
  background: rgba(49, 230, 164, 0.08);
}

.wallet-recovery-message,
.wallet-recovery-error {
  padding: 11px 13px;
  border-radius: 14px;
  text-align: left;
  font-size: 0.88rem;
}

.wallet-recovery-message {
  color: #e9fff7;
  border: 1px solid rgba(49, 230, 164, 0.18);
  background: rgba(49, 230, 164, 0.08);
}

.wallet-recovery-error {
  color: #ffd8d2;
  border: 1px solid rgba(255, 127, 114, 0.18);
  background: rgba(255, 127, 114, 0.08);
}

.wallet-recovery-help {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 12px;
  border-radius: 14px;
  border: 1px solid rgba(240, 202, 115, 0.16);
  background: rgba(240, 202, 115, 0.06);
  color: rgba(245, 240, 229, 0.86);
  font-size: 0.79rem;
  line-height: 1.35;
  text-align: center;
}

.wallet-recovery-help::before {
  content: '⏱';
  font-size: 0.88rem;
  opacity: 0.92;
}

.wallet-recovery-form,
.wallet-recovery-done {
  display: grid;
  gap: 12px;
}

.wallet-recovery-field {
  display: grid;
  gap: 7px;
}

.wallet-recovery-field span {
  color: var(--wallet-text-soft);
  font-size: 0.78rem;
}

.wallet-recovery-field input {
  min-height: 48px;
  padding: 0 14px;
  border-radius: 13px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
  color: var(--wallet-text);
  font-size: 0.94rem;
}

.wallet-recovery-field input::placeholder {
  color: rgba(233, 238, 241, 0.48);
}

.wallet-recovery-field input:disabled {
  opacity: 0.86;
}

.wallet-recovery-field input:focus {
  outline: 2px solid rgba(49, 230, 164, 0.5);
  outline-offset: 2px;
}

.wallet-recovery-primary,
.wallet-recovery-secondary {
  min-height: 48px;
  border-radius: 13px;
  font-size: 0.94rem;
  cursor: pointer;
  transition: transform 180ms ease, filter 180ms ease, box-shadow 180ms ease;
}

.wallet-recovery-primary {
  border: 1px solid rgba(49, 230, 164, 0.3);
  color: #e7fff7;
  font-weight: 700;
  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.14),
    0 12px 24px rgba(0, 0, 0, 0.22),
    0 0 22px rgba(49, 230, 164, 0.12);
}

.wallet-recovery-primary--cooldown {
  border-color: rgba(240, 202, 115, 0.26);
  color: #fff5d7;
  background: linear-gradient(180deg, rgba(240, 202, 115, 0.18) 0%, rgba(88, 67, 17, 0.9) 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.12),
    0 12px 24px rgba(0, 0, 0, 0.2),
    0 0 18px rgba(240, 202, 115, 0.12);
}

.wallet-recovery-primary__label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.wallet-recovery-primary__label::before {
  content: '↻';
  font-size: 0.82rem;
  opacity: 0.9;
}

.wallet-recovery-primary--cooldown .wallet-recovery-primary__label::before {
  content: '⏳';
}

.wallet-recovery-secondary {
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
  color: var(--wallet-text-soft);
}

.wallet-recovery-primary:hover:not(:disabled),
.wallet-recovery-secondary:hover:not(:disabled) {
  transform: translateY(-1px);
  filter: brightness(1.03);
}

.wallet-recovery-primary:disabled,
.wallet-recovery-secondary:disabled {
  opacity: 0.64;
  cursor: not-allowed;
}

.wallet-recovery-footer {
  text-align: center;
  padding-top: 2px;
}

.wallet-recovery-footer a {
  color: var(--wallet-text-soft);
  font-size: 0.84rem;
}

@media (max-width: 480px) {
  .wallet-recovery-page {
    padding:
      calc(12px + var(--app-safe-top, 0px))
      calc(12px + var(--app-safe-right, 0px))
      calc(16px + var(--app-safe-bottom, 0px))
      calc(12px + var(--app-safe-left, 0px));
  }

  .wallet-recovery-shell {
    width: min(100%, 420px);
    padding: 16px;
    border-radius: 24px;
  }

  .wallet-recovery-stepper span,
  .wallet-recovery-field input,
  .wallet-recovery-primary,
  .wallet-recovery-secondary {
    min-height: 46px;
    border-radius: 12px;
  }

  .wallet-recovery-help {
    padding: 10px 11px;
    font-size: 0.76rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/RecoverPasswordPage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,6CAA6C;EAC7C,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB;;;;0CAIwC;EACxC,yBAAyB;EACzB;;;mGAGiG;EACjG,wFAAwF;AAC1F;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;2EAEyE;EACzE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,2CAA2C;EAC3C,2CAA2C;AAC7C;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EACR;;0EAEwE;EACxE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,gBAAgB;EAChB,6FAA6F;EAC7F;;;qCAGmC;AACrC;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,6FAA6F;EAC7F;;;sCAGoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;IACE;;;;4CAIwC;EAC1C;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;EACrB;;EAEA;;;;IAIE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF","sourcesContent":[".wallet-recovery-page {\n  --wallet-bg-1: #07131b;\n  --wallet-bg-2: #0b1d29;\n  --wallet-bg-3: #04080c;\n  --wallet-emerald: #31e6a4;\n  --wallet-gold: #f0ca73;\n  --wallet-text: #f5f0e5;\n  --wallet-text-soft: rgba(233, 238, 241, 0.74);\n  --wallet-panel: rgba(7, 16, 22, 0.96);\n  --wallet-border: rgba(100, 197, 170, 0.14);\n  min-height: 100vh;\n  min-height: 100dvh;\n  position: relative;\n  overflow: hidden;\n  display: grid;\n  place-items: center;\n  padding:\n    calc(16px + var(--app-safe-top, 0px))\n    calc(16px + var(--app-safe-right, 0px))\n    calc(20px + var(--app-safe-bottom, 0px))\n    calc(16px + var(--app-safe-left, 0px));\n  color: var(--wallet-text);\n  background:\n    radial-gradient(circle at top center, rgba(53, 109, 92, 0.26) 0%, rgba(7, 19, 27, 0) 34%),\n    radial-gradient(circle at 18% 82%, rgba(240, 202, 115, 0.1) 0%, rgba(7, 19, 27, 0) 28%),\n    linear-gradient(180deg, var(--wallet-bg-1) 0%, var(--wallet-bg-2) 52%, var(--wallet-bg-3) 100%);\n  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;\n}\n\n.wallet-recovery-page::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px);\n  background-size: 16px 16px;\n  opacity: 0.5;\n}\n\n.wallet-recovery-shell {\n  position: relative;\n  width: min(100%, 440px);\n  padding: 18px;\n  border-radius: 28px;\n  overflow: hidden;\n  background: var(--wallet-panel);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 28px 56px rgba(0, 0, 0, 0.42);\n}\n\n.wallet-recovery-shell__noise,\n.wallet-recovery-shell__halo {\n  position: absolute;\n  pointer-events: none;\n}\n\n.wallet-recovery-shell__noise {\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.014) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.01) 1px, transparent 1px);\n  background-size: 12px 12px;\n  opacity: 0.22;\n}\n\n.wallet-recovery-shell__halo {\n  width: 220px;\n  height: 220px;\n  border-radius: 50%;\n  filter: blur(34px);\n}\n\n.wallet-recovery-shell__halo--top {\n  top: -110px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(24, 180, 127, 0.14);\n}\n\n.wallet-recovery-shell__halo--bottom {\n  right: -100px;\n  bottom: -130px;\n  background: rgba(240, 202, 115, 0.08);\n}\n\n.wallet-recovery-brand,\n.wallet-recovery-card {\n  position: relative;\n  z-index: 1;\n}\n\n.wallet-recovery-brand {\n  display: grid;\n  gap: 14px;\n  justify-items: center;\n  text-align: center;\n  margin-bottom: 16px;\n}\n\n.wallet-recovery-brand__logo {\n  width: 96px;\n  max-width: 38vw;\n  object-fit: contain;\n  filter: drop-shadow(0 14px 24px rgba(0, 0, 0, 0.34));\n}\n\n.wallet-recovery-brand__copy span {\n  display: block;\n  font-size: 0.74rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: rgba(233, 238, 241, 0.6);\n}\n\n.wallet-recovery-brand__copy h1 {\n  margin: 6px 0 0;\n  font-size: clamp(1.1rem, 4.8vw, 1.45rem);\n  line-height: 1.18;\n  font-weight: 700;\n}\n\n.wallet-recovery-card {\n  display: grid;\n  gap: 14px;\n}\n\n.wallet-recovery-stepper {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n.wallet-recovery-stepper span {\n  padding: 9px 10px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--wallet-text-soft);\n  text-align: center;\n  font-size: 0.76rem;\n}\n\n.wallet-recovery-stepper .is-active {\n  color: #eafff7;\n  border-color: rgba(49, 230, 164, 0.22);\n  background: rgba(49, 230, 164, 0.08);\n}\n\n.wallet-recovery-message,\n.wallet-recovery-error {\n  padding: 11px 13px;\n  border-radius: 14px;\n  text-align: left;\n  font-size: 0.88rem;\n}\n\n.wallet-recovery-message {\n  color: #e9fff7;\n  border: 1px solid rgba(49, 230, 164, 0.18);\n  background: rgba(49, 230, 164, 0.08);\n}\n\n.wallet-recovery-error {\n  color: #ffd8d2;\n  border: 1px solid rgba(255, 127, 114, 0.18);\n  background: rgba(255, 127, 114, 0.08);\n}\n\n.wallet-recovery-help {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 11px 12px;\n  border-radius: 14px;\n  border: 1px solid rgba(240, 202, 115, 0.16);\n  background: rgba(240, 202, 115, 0.06);\n  color: rgba(245, 240, 229, 0.86);\n  font-size: 0.79rem;\n  line-height: 1.35;\n  text-align: center;\n}\n\n.wallet-recovery-help::before {\n  content: '⏱';\n  font-size: 0.88rem;\n  opacity: 0.92;\n}\n\n.wallet-recovery-form,\n.wallet-recovery-done {\n  display: grid;\n  gap: 12px;\n}\n\n.wallet-recovery-field {\n  display: grid;\n  gap: 7px;\n}\n\n.wallet-recovery-field span {\n  color: var(--wallet-text-soft);\n  font-size: 0.78rem;\n}\n\n.wallet-recovery-field input {\n  min-height: 48px;\n  padding: 0 14px;\n  border-radius: 13px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n  color: var(--wallet-text);\n  font-size: 0.94rem;\n}\n\n.wallet-recovery-field input::placeholder {\n  color: rgba(233, 238, 241, 0.48);\n}\n\n.wallet-recovery-field input:disabled {\n  opacity: 0.86;\n}\n\n.wallet-recovery-field input:focus {\n  outline: 2px solid rgba(49, 230, 164, 0.5);\n  outline-offset: 2px;\n}\n\n.wallet-recovery-primary,\n.wallet-recovery-secondary {\n  min-height: 48px;\n  border-radius: 13px;\n  font-size: 0.94rem;\n  cursor: pointer;\n  transition: transform 180ms ease, filter 180ms ease, box-shadow 180ms ease;\n}\n\n.wallet-recovery-primary {\n  border: 1px solid rgba(49, 230, 164, 0.3);\n  color: #e7fff7;\n  font-weight: 700;\n  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.14),\n    0 12px 24px rgba(0, 0, 0, 0.22),\n    0 0 22px rgba(49, 230, 164, 0.12);\n}\n\n.wallet-recovery-primary--cooldown {\n  border-color: rgba(240, 202, 115, 0.26);\n  color: #fff5d7;\n  background: linear-gradient(180deg, rgba(240, 202, 115, 0.18) 0%, rgba(88, 67, 17, 0.9) 100%);\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.12),\n    0 12px 24px rgba(0, 0, 0, 0.2),\n    0 0 18px rgba(240, 202, 115, 0.12);\n}\n\n.wallet-recovery-primary__label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.wallet-recovery-primary__label::before {\n  content: '↻';\n  font-size: 0.82rem;\n  opacity: 0.9;\n}\n\n.wallet-recovery-primary--cooldown .wallet-recovery-primary__label::before {\n  content: '⏳';\n}\n\n.wallet-recovery-secondary {\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--wallet-text-soft);\n}\n\n.wallet-recovery-primary:hover:not(:disabled),\n.wallet-recovery-secondary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  filter: brightness(1.03);\n}\n\n.wallet-recovery-primary:disabled,\n.wallet-recovery-secondary:disabled {\n  opacity: 0.64;\n  cursor: not-allowed;\n}\n\n.wallet-recovery-footer {\n  text-align: center;\n  padding-top: 2px;\n}\n\n.wallet-recovery-footer a {\n  color: var(--wallet-text-soft);\n  font-size: 0.84rem;\n}\n\n@media (max-width: 480px) {\n  .wallet-recovery-page {\n    padding:\n      calc(12px + var(--app-safe-top, 0px))\n      calc(12px + var(--app-safe-right, 0px))\n      calc(16px + var(--app-safe-bottom, 0px))\n      calc(12px + var(--app-safe-left, 0px));\n  }\n\n  .wallet-recovery-shell {\n    width: min(100%, 420px);\n    padding: 16px;\n    border-radius: 24px;\n  }\n\n  .wallet-recovery-stepper span,\n  .wallet-recovery-field input,\n  .wallet-recovery-primary,\n  .wallet-recovery-secondary {\n    min-height: 46px;\n    border-radius: 12px;\n  }\n\n  .wallet-recovery-help {\n    padding: 10px 11px;\n    font-size: 0.76rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
